import React, { CSSProperties, FunctionComponent, ReactElement } from 'react';

const DEFAULT_COLOR = '#6BBE27';
const DEFAULT_WAI_ARIA_ATTRIBUTE = {
	'aria-busy': true,
	role: 'progressbar',
};

interface SpinnerProps {
	/** Height of the spinner. Can be a string (e.g., '32px') or a number */
	height?: string | number;
	/** Width of the spinner. Can be a string (e.g., '32px') or a number */
	width?: string | number;
	/** Accessible label for the spinner */
	ariaLabel?: string;
	/** Custom styles to apply to the spinner wrapper */
	wrapperStyle?: CSSProperties;
	/** CSS class name to apply to the spinner wrapper */
	wrapperClass?: string;
	/** Whether the spinner should be visible */
	visible?: boolean;
	/** Color of the spinner */
	color?: string;
}

export const LoadingSpinner: FunctionComponent<SpinnerProps> = ({
	visible = true,
	width = '32',
	height = '32',
	color = DEFAULT_COLOR,
	wrapperClass = '',
	wrapperStyle = {},
	ariaLabel = 'loading-spinner',
}): ReactElement | null => {
	return !visible ? null : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 100 100"
			preserveAspectRatio="xMidYMid"
			className={wrapperClass}
			style={wrapperStyle}
			aria-label={ariaLabel}
			data-testid="spinner-svg"
			{...DEFAULT_WAI_ARIA_ATTRIBUTE}
		>
			<circle
				cx="50"
				cy="50"
				fill="none"
				stroke={color}
				strokeWidth="8"
				r="35"
				strokeDasharray="164.93361431346415 56.97787143782138"
			>
				<animateTransform
					attributeName="transform"
					type="rotate"
					repeatCount="indefinite"
					dur="1s"
					values="0 50 50;360 50 50"
					keyTimes="0;1"
				/>
			</circle>
		</svg>
	);
};
